import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../baseQuery";
import { AnalyticsProperties, logger } from "@timeedit/registration-components";

interface AnalyticsEvent {
  event: string;
  properties?: AnalyticsProperties;
}

export const analyticsApiSlice = createApi({
  reducerPath: "analyticsApi",
  baseQuery,
  endpoints: (builder) => ({
    analyticsEvent: builder.mutation<void, AnalyticsEvent>({
      queryFn: async (body, _api, _extraOptions, baseQuery) => {
        try {
          const result = baseQuery({
            url: "/analytics-event",
            method: "POST",
            body,
          });

          Promise.resolve(result)
            .then((response) => {
              if (response.error) {
                logger.error("Analytics grouping failed:", response.error);
              }
            })
            .catch((error: unknown) => {
              logger.error("Analytics grouping failed:", error);
            });

          return { data: undefined };
        } catch (error) {
          logger.error("Analytics grouping failed:", error);
          return { data: undefined };
        }
      },
    }),
  }),
});

export const { useAnalyticsEventMutation } = analyticsApiSlice;
